module.exports = __webpack_public_path__ + "img/tire-desktop.d82529d.png";